import { connect } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        profile: state.profile.profile,
    });
    return connect(mapState, () => ({}))(Component);
}
